import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import FullscreenOutlinedIcon from "@mui/icons-material/FullscreenOutlined";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import {useTranslation} from "react-i18next";
import {useServerTableContext} from "../ServerTableContext";
import {
    useServerTableToolbarContext,
    useServerTableToolbarItemContext
} from "../ServerTableToolbarContext";
import {defineServerTableToolbarItem} from "../ServerTableToolbarItem";
import {serverTableControlIconSx, serverTableControlSx} from "../constants";

const ServerTableFullscreenComponent = () => {
    const {t} = useTranslation();
    const {isFullScreen, setIsFullScreen} = useServerTableContext();
    const {closePanel} = useServerTableToolbarContext();
    const toolbarItem = useServerTableToolbarItemContext();
    const label = t(isFullScreen ? 'Exit full screen' : 'Enter full screen');
    const toggleFullscreen = () => {
        closePanel();
        toolbarItem.closeMenu();
        setIsFullScreen(!isFullScreen);
    };

    if (toolbarItem.presentation === 'menu') {
        return (
            <MenuItem onClick={toggleFullscreen}>
                {isFullScreen
                    ? <FullscreenExitOutlinedIcon fontSize="small" sx={{mr: 1, color: 'primary.main'}}/>
                    : <FullscreenOutlinedIcon fontSize="small" sx={{mr: 1, color: 'primary.main'}}/>}
                {label}
            </MenuItem>
        );
    }

    return (
        <Tooltip title={label}>
            <IconButton
                size="small"
                color="primary"
                data-dashboard-control=""
                data-active={isFullScreen || undefined}
                aria-label={label}
                aria-pressed={isFullScreen}
                onClick={toggleFullscreen}
                sx={serverTableControlSx}
            >
                {isFullScreen
                    ? <FullscreenExitOutlinedIcon sx={serverTableControlIconSx}/>
                    : <FullscreenOutlinedIcon sx={serverTableControlIconSx}/>}
            </IconButton>
        </Tooltip>
    );
};

export const ServerTableFullscreen = defineServerTableToolbarItem(ServerTableFullscreenComponent);
